import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id"]
const _hoisted_3 = {
  key: 0,
  style: {"width":"280px","height":"160px","padding":"16px","border":"2px solid #16a34a","border-radius":"10px","display":"flex","align-items":"center","gap":"14px","font-family":"Arial, sans-serif","color":"#065f46","position":"relative","opacity":".3"}
}
const _hoisted_4 = {
  width: "40",
  height: "40",
  viewBox: "0 0 24 24",
  fill: "none",
  style: {"flex-shrink":"0"}
}
const _hoisted_5 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_6 = { style: {"font-size":"15px","font-weight":"bold"} }
const _hoisted_7 = { style: {"font-size":"13px","color":"#0f7a58"} }
const _hoisted_8 = {
  key: 1,
  role: "status",
  "aria-live": "polite",
  style: {"width":"280px","height":"160px","position":"relative","border":"2px dashed #cfcfcf","border-radius":"8px","display":"flex","align-items":"center","justify-content":"center","flex-direction":"column","color":"#666","font-family":"system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial","background":"#fafafa"}
}
const _hoisted_9 = {
  width: "40",
  height: "40",
  viewBox: "0 0 24 24",
  fill: "none",
  "aria-hidden": "true",
  style: {"margin-bottom":"8px","opacity":".8"}
}
const _hoisted_10 = { style: {"font-size":"14px","font-weight":"600"} }

import { computed, reactive } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomBlocFileInput',
  props: {
        id: { type: String, required: true },
        title: { type: String, required: true },
        description: { type: String, default: '' },
        url: { type: String, required: false },
        isUploaded: { type: Boolean, required: false },
        preview: { type: String }
    },
  emits: ["uploaded"],
  setup(__props, { emit: __emit }) {

    const emit = __emit;
    const props = __props;
    const formValue = reactive({
        file: '',
        file_name: '',
        file_preview: null as any,
    });
    const previewComponent = computed(() => formValue.file_preview ?? props.preview);
    const isFileUploaded = computed(() => formValue.file ?? props.isUploaded);

    function onFileUploaded(event: any) {
        if (event.target.files.length > 0) {
            var reader = new FileReader();
            reader.onload = function(e) {
                formValue.file = event.target.files[0];
                formValue.file_name = event.target.files[0].name;
                formValue.file_preview = e.target!.result as string;
                emit('uploaded', formValue);
            }
            reader.readAsDataURL(event.target.files[0]);
        }
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    for: props.id,
    style: {"cursor":"pointer"}
  }, [
    _createElementVNode("input", {
      id: props.id,
      class: "display-none",
      type: "file",
      onChange: _cache[0] || (_cache[0] = ($event: any) => (onFileUploaded($event)))
    }, null, 40, _hoisted_2),
    (isFileUploaded.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (previewComponent.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                style: _normalizeStyle([{ background: `url('${previewComponent.value ?? ''}')`, backgroundSize: 'cover', backgroundPosition: 'center' }, {"position":"absolute","left":"0","top":"0","right":"0","bottom":"0","opacity":".2"}])
              }, " ", 4))
            : _createCommentVNode("", true),
          (_openBlock(), _createElementBlock("svg", _hoisted_4, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("path", {
              d: "M4 3h10l6 6v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z",
              stroke: "#065f46",
              "stroke-width": "1.5",
              fill: "none"
            }, null, -1),
            _createElementVNode("path", {
              d: "M14 3v6h6",
              stroke: "#065f46",
              "stroke-width": "1.5",
              fill: "none"
            }, null, -1),
            _createElementVNode("path", {
              d: "M8 15l3 3 6-6",
              stroke: "#16a34a",
              "stroke-width": "2",
              fill: "none",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, -1)
          ]))])),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, " Fichier : " + _toDisplayString(formValue.file_name || __props.title), 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString(__props.description), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (!isFileUploaded.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (previewComponent.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                style: _normalizeStyle([{ background: `url('${previewComponent.value ?? ''}')`, backgroundSize: 'cover', backgroundPosition: 'center' }, {"position":"absolute","left":"0","top":"0","right":"0","bottom":"0","opacity":".2"}])
              }, " ", 4))
            : _createCommentVNode("", true),
          (_openBlock(), _createElementBlock("svg", _hoisted_9, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("path", {
              d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z",
              stroke: "#999",
              "stroke-width": "1.2",
              fill: "none"
            }, null, -1),
            _createElementVNode("path", {
              d: "M14 2v6h6",
              stroke: "#999",
              "stroke-width": "1.2",
              fill: "none"
            }, null, -1),
            _createElementVNode("path", {
              d: "M8 13h8M8 17h5",
              stroke: "#999",
              "stroke-width": "1.2",
              "stroke-linecap": "round"
            }, null, -1)
          ]))])),
          _createElementVNode("div", _hoisted_10, _toDisplayString(__props.title), 1),
          _cache[3] || (_cache[3] = _createElementVNode("div", { style: {"font-size":"12px","margin-top":"6px","color":"#9a9a9a"} }, "Aucun fichier uploadé", -1))
        ]))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})